import { log } from '@/src/lib/logger/business/log';

export async function logResponse(response: Response) {
  const clonedResponse = response?.clone ? response.clone() : response;
  log({
    message: [
      `Response ${response.url} ${response.status}`,
      {
        headers: Object.fromEntries(response.headers?.entries() || []),
        body: await clonedResponse.text(),
      },
    ],
  });
}
